import React, { memo } from 'react'
import { FiCopy } from 'react-icons/fi'

import { useAlert } from 'common/components/Alert/hooks/useAlert'

const CopyToCllipboardButton = ({ buttonRef, data, customClassName, iconClassName }) => {
  const { createAlert } = useAlert()

  return (
    <button
      ref={buttonRef}
      onClick={() =>
        navigator.clipboard.writeText(data).then(() => {
          createAlert({ text: 'Copied to clipboard', type: 'success' })
        })
      }
      className={customClassName ? customClassName : 'ml-[10px] opacity-30 cursor-pointer'}
      type='button'
    >
      <FiCopy className={iconClassName} />
    </button>
  )
}

export default memo(CopyToCllipboardButton)
